import { Fade, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { usePortal_GetPortalsByConciergeUserIdQuery } from 'queries';

import HomeLayout from 'layouts/home-layout';
import ClientActivity from 'pages/common/client/client-activity';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import ConciergeActions from './components/concierge-actions';
import MyClients from './components/my-clients';

type Props = {
  id: string;
};

const useStyles = makeStyles(() => ({
  container: {
    padding: '5%',
    flexGrow: 1,
  },
  activityContainer: {
    marginTop: '12px',
    paddingLeft: '12px',
  },
}));

const ConciergeDashboard = ({ id }: Props) => {
  const classes = useStyles();
  const { data: portalsData, loading: portalsLoading } = usePortal_GetPortalsByConciergeUserIdQuery(
    {
      variables: { id },
      onError: (e) => {
        showAlert({
          message: 'Error getting portals by concierge ID: ' + e.message,
          severity: NotificationSeverity.ERROR,
        });
      },
    },
  );

  return (
    <HomeLayout showPortalName={false}>
      <Fade in={true}>
        <div className={classes.container}>
          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <ConciergeActions />
              <Grid>{portalsData && !portalsLoading && <MyClients />}</Grid>
            </Grid>
            <Grid container md={6} xs={12} className={classes.activityContainer}>
              <ClientActivity />
            </Grid>
          </Grid>
        </div>
      </Fade>
    </HomeLayout>
  );
};
export default ConciergeDashboard;
